export default __webpack_public_path__ + "static/2019_01-e0c22c7246833dfc267979556266703d.png";